import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer-inner">
      <div className="footer-top">
        <div className="footer-brand">
          <div className="footer-logo">
            <img src="/axtion-logo.png" alt="aXtion Technologies" style={{ height: '120px', width: 'auto' }} />
          </div>
          <p className="footer-tagline">Preparing for your success</p>
          <p className="footer-contact-block">
            <a href="mailto:info@axtiontechnologies.com">info@axtiontechnologies.com</a><br />
            <a href="tel:+17035777500">+1 703-577-7500</a><br />
            Stafford, VA and Freetown SL
          </p>
        </div>
        <div className="footer-links-group">
          <h4>Solutions</h4>
          <ul>
            <li><a href="#services">aXtion Telemed</a></li>
            <li><a href="#services">aXtion EHR Systems</a></li>
            <li><a href="#services">aXtion Students Portal</a></li>
            <li><a href="#services">Fintech Integration</a></li>
            <li><a href="#services">Enterprise Software Solutions</a></li>
          </ul>
        </div>
        <div className="footer-links-group">
          <h4>Company</h4>
          <ul>
            <li><a href="#about">About Us</a></li>
            <li><a href="#projects">Our Solutions</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>
        <div className="footer-links-group">
          <h4>Follow</h4>
          <ul>
            <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a></li>
            <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
            <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter/X</a></li>
            <li><a href="https://youtube.com" target="_blank" rel="noopener noreferrer">YouTube</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-line"></div>
        <div className="footer-meta">
          <span>© Copyright {new Date().getFullYear()}. All Rights Reserved by aXtion Technologies</span>
          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
